"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userInfoService = void 0;
var userInfoService_1 = require("./userInfoService");
Object.defineProperty(exports, "userInfoService", { enumerable: true, get: function () { return __importDefault(userInfoService_1).default; } });
